import "core-js/modules/es.array.push.js";
import { isShowQuestionDialog } from "@/utils";
import { Dialog, DialogPanel, DialogTitle, TransitionRoot, TransitionChild } from "@headlessui/vue";
import { IdentificationIcon } from "@heroicons/vue/24/outline";
export default {
  name: "HeaderAbout",
  components: {
    Dialog,
    DialogPanel,
    DialogTitle,
    TransitionRoot,
    TransitionChild,
    IdentificationIcon
  },
  data() {
    return {
      isDialogOpen: false,
      openBeforeQuestionnaire: false
    };
  },
  computed: {
    developers() {
      const avatars2 = ['/avatar_lcy.jpg', '/avatar_pyf.jpeg'];
      if (this.$i18n.locale === 'zh') {
        return [{
          name: "李云聪",
          description: "香港理工大学研究助理。曾在百度、腾讯、粤港澳大湾区数字经济研究院从事自然语言处理、推荐等方向的工作，并在相关顶会EMNLP、SIGIR、RecSys上发表论文。帮你写项目的后端开发。"
        }].map((item, i) => ({
          ...item,
          avatar: avatars2[i]
        }));
      } else {
        return [{
          name: "Li Yuncong",
          description: "Research Assistant at The Hong Kong Polytechnic University. Previously worked at Baidu, Tencent, and International Digital Economy Academy in the fields of natural language processing and recommendation systems, with papers published at top-tier conferences including EMNLP, SIGIR, and RecSys. Responsible for backend development of Write4U."
        }].map((item, i) => ({
          ...item,
          avatar: avatars2[i]
        }));
      }
    },
    tt() {
      return `<span>香港理工大学计算学系攻读博士学位。其研究兴趣主要包括异常事件检测和脑电图分析。论文第一作者，<span>帮你写</span>的算法设计者和系统架构师。</span>`;
    },
    authors() {
      const avatars1 = ['/avatar_zz.jpg', '/avatar_ly.jpg', '/avatar_hzj.jpg', '/avatar_cg.jpg', '/avatar_zsh.jpg', '/avatar_yy.jpg', '/avatar_cjn.jpg'];
      if (this.$i18n.locale === "zh") {
        return [{
          name: "张智",
          description:
          // `<span>香港理工大学计算学系攻读博士学位。其研究兴趣主要包括异常事件检测和脑电图分析。论文第一作者，<span>帮你写</span>的算法设计者和系统架构师。</span>`,
          "香港理工大学电子计算学系博士研究生。研究兴趣包括人工智能、脑电数据分析和多模态情感计算。论文第一作者，帮你写的算法设计者和系统架构师。"
        }, {
          name: "刘焱教授*",
          description: "哥伦比亚大学计算机科学博士学位。现任香港理工大学电子计算学系人工智能和机器人研究组组长、认知计算实验室主任。研究兴趣包括生成式人工智能、脑建模和认知计算、计算机音乐和计算机视觉。论文通讯作者，帮你写的项目负责人。"
        }, {
          name: "胡喆靖博士",
          description: "胡博士2023年于香港理工大学获得人工智能专业博士学位；此前分别于哥伦比亚大学及新泽西州立大学获得硕士及学士学位。胡博士负责基于大语言模型的去幻觉算法设计。"
        }, {
          name: "陈功博士",
          description: "香港理工大学计算机科学博士学位，香港理工大学校友，帮你写项目发起人。"
        }, {
          name: "钟圣华教授",
          description: "香港理工大学计算学系博士学位，香港理工大学校友。研究兴趣包括多媒体计算、脑科学和机器学习。论文共同作者。"
        }, {
          name: "杨宇教授",
          description: "香港理工大学计算机科学博士学位，香港理工大学校友。研究兴趣包括时空数据分析、表示学习、城市计算和学习分析。论文共同作者。"
        }, {
          name: "曹建农教授",
          description: "华盛顿州立大学计算机科学博士学位。现为香港理工大学副校长、潘乐陶慈善基金数据科学教授、分布式与移动计算讲座教授、人工智能与物联网研究院主任和大数据分析中心实验室主任。论文共同作者。"
        }
        // ].map((item, i)=>({...item, avatar:avatars1[i]}));
        ].map((item, i) => ({
          ...item,
          avatar: avatars1[i]
        }));
      } else {
        return [{
          name: "Zhang Zhi",
          description: "Ph.D. student in the Department of Computing at The Hong Kong Polytechnic University. Research interests include artificial intelligence, EEG data analysis, and multimodal affective computing. First author of the paper, algorithm designer and system architect of Write4U."
        }, {
          name: "Prof. Liu Yan*",
          description: "Ph.D. in Computer Science from Columbia University. Currently leads the AI and Robotics Research Group and directs the Cognitive Computing Lab at The Hong Kong Polytechnic University. Research interests include generative AI, brain modeling and cognitive computing, computer music, and computer vision. Corresponding author of the paper, project lead of Write4U."
        }, {
          name: "Dr. Hu Zhejing",
          description: "Dr. Hu obtained his PhD in Artificial Intelligence from The Hong Kong Polytechnic University in 2023; prior to that, he earned his Master's and Bachelor's degrees from Columbia University and Rutgers University, respectively. Dr. Hu is responsible for the design of hallucination mitigation algorithms based on large language models."
        }, {
          name: "Dr. Chen Gong",
          description: "Ph.D. in Computer Science from The Hong Kong Polytechnic University. PolyU alumnus, initiator of Write4U."
        }, {
          name: "Prof. Zhong Shenghua",
          description: "Ph.D. in Computing from The Hong Kong Polytechnic University. PolyU alumnus. Research interests include multimedia computing, brain science, and machine learning. Co-author of the paper."
        }, {
          name: "Prof. Yang Yu",
          description: "Ph.D. in Computer Science from The Hong Kong Polytechnic University. PolyU alumnus. Research interests include spatiotemporal data analysis, representation learning, urban computing, and learning analytics. Co-author of the paper."
        }, {
          name: "Prof. Cao Jiannong",
          description: "Ph.D. in Computer Science from Washington State University. Currently Vice President of The Hong Kong Polytechnic University, Otto Poon Charitable Foundation Professor in Data Science, Chair Professor of Distributed and Mobile Computing, Director of the Research Institute for Artificial Intelligence of Things, and Director of the Big Data Analytics Center. Co-author of the paper."
        }].map((item, i) => ({
          ...item,
          avatar: avatars1[i]
        }));
      }
    }
  },
  watch: {
    "$route.hash"(newHash) {
      if (newHash === "#questionnaire" && this.isDialogOpen === true) {
        this.isDialogOpen = false;
        this.openBeforeQuestionnaire = true;
      } else {
        if (this.openBeforeQuestionnaire === true) {
          this.openBeforeQuestionnaire = false;
          this.isDialogOpen = true;
        }
      }
    }
  },
  methods: {
    openDialog() {
      this.isDialogOpen = true;
    },
    closeDialog() {
      if (isShowQuestionDialog()) {
        return;
      }
      this.isDialogOpen = false;
    },
    feedbackForm() {
      this.$router.push({
        hash: "#questionnaire"
      });
      // Message.text(this.$i18n.locale === 'zh' ? "尚未开放，敬请期待！" : "Coming Soon")
    }
  }
};